import { assetVariantAtom } from '../lendAndBorrow';
import { Decimal } from '../../datastructures';
import poolsUserBalanceAtom from '../pool/poolsUserBalanceAtom';
import { walletAddressAtom } from '../wallet';
import { createAsyncAtom } from '../../lib/state';
import lendAndBorrowPositionsAtom from './lendAndBorrowPositions';

const userYieldingPositionsAtom = createAsyncAtom(async get => {
  const lendAndBorrowPositions = await get(lendAndBorrowPositionsAtom);
  const poolPositions = await get(poolsUserBalanceAtom);
  const assetVariantMap = await get(assetVariantAtom);
  const walletAddress = await get(walletAddressAtom);

  if (!assetVariantMap || !walletAddress) {
    return Decimal.ZERO;
  }

  let yieldingPositions = new Decimal(0);
  if (lendAndBorrowPositions) {
    Object.entries(lendAndBorrowPositions).forEach(([, accountPositions]) => {
      accountPositions.forEach(position => {
        const assetVariant = assetVariantMap[`${walletAddress}-${position.accountId}-${position.asset.address}`];
        if (assetVariant.isLending) {
          yieldingPositions = yieldingPositions.add(position.lendBalanceUsd);
        }
      });
    });
  }

  Object.entries(poolPositions).forEach(([, value]) => {
    yieldingPositions = yieldingPositions.add(value);
  });

  return yieldingPositions;
});

export default userYieldingPositionsAtom;
